import { Component, OnInit, OnDestroy, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AppCoreService } from "src/app/services/app-core.service";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserManagementService } from "src/app/services/user-management.service";
import { EditRoleComponent } from "./editrole.component";
import { Title } from "@angular/platform-browser";
import { Utilities } from "src/app/models/utilities";

@Component({
  selector: 'app-addroles',
  templateUrl: './addroles.component.html',
  styleUrls: ['./addroles.component.scss']
})
export class AddRolesComponent implements OnInit, OnDestroy, AfterViewInit {
  // private modalService = inject(NgbModal);
  closeResult = '';

  roleForm: FormGroup;
  isFormSubmitted = false;
  roleList = [];
  isActionAllowed = true;
  userGroupList: any[];
  isCollapsed = false;
  isCollapsed1 = false;
  useEnterKey: any;
  userData;

  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private userManagementService: UserManagementService,
    public modalService: NgbModal,
    private titleService: Title,
    private utilities: Utilities,
  ) {
    titleService.setTitle('Roles');
  }

  ngOnInit(): void {
    this.userData = this.appCoreService.GetUserData();

    this.roleForm = this.formBuilder.group({
      ddlGroups: [null, Validators.compose([Validators.required])],
      txtRoleName: [null, Validators.compose([Validators.required, Validators.maxLength(40), Validators.pattern(/^[a-zA-Z0-9- ]*$/)])]
    });
    this.useEnterKey = !this.userData.metaInfo.tabbasedtemplate;

    this.bindUserGroups();
    this.bindRoleList();
    this.checkPermission();
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.roleForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'Roles');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  bindUserGroups() {
    try {
      this.userManagementService.GetAllUserGroups({ groupid: this.userData.groupId }).subscribe((res) => {
        if (res?.success) {
          this.userGroupList = res?.data;
          if (this.appCoreService.GetUserData()?.accessType === 'Customer') {
            this.userGroupList = res?.data.find(x => x.name === 'Customer Admin');
            this.roleForm.get('ddlGroups').setValue([{ value: this.userGroupList[0]?.id, disabled: true }]);
          }
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  bindRoleList(refresh = false) {
    try {
      this.ngxLoaderService.start();
      this.userManagementService.GetAllRoles({ refresh: refresh }).subscribe((res: any) => {
        if (res && res.success) {
          // console.log(res);
          this.ngxLoaderService.stop();
          this.roleList = res.data;
          // console.log('roleList', this.roleList);
        } else {
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  ngOnDestroy(): void {

  }

  addRole() {
    try {
      this.isFormSubmitted = true;
      if (this.roleForm.valid) {
        let selectedGroupName = this.userGroupList.filter(x => x.id === this.roleForm.get('ddlGroups').value)[0].name;
        const reqObj = {
          groupid: this.roleForm.get('ddlGroups').value,
          groupname: selectedGroupName,
          rolename: this.roleForm.get('txtRoleName').value,
          isactive: true
        };

        this.ngxLoaderService.start();
        this.userManagementService.AddRole(reqObj).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            if (res.data.length) {
              this.appCoreService.showMessage('Role Added successfully.', 'Success');
              this.bindRoleList(true);
              this.resetForm();
            }

          } else if (res && !res.success) {
            this.openErrorDialog(res.error.message);
          }
        });
        this.ngxLoaderService.stop();
      }
    }
    catch (err) {
      console.error(err);
    }
  }

  onDeleteRole(roleId) {
    if (roleId) {
      let deleteMsg = '';
      let userCount = this.roleList.filter(x => x.id === roleId)[0].usercount;

      if (userCount > 0) {
        deleteMsg = `Currently ${userCount} user/s are mapped under this role and deleting it will de-activate all the users of this role. `;
      }
      deleteMsg = deleteMsg + 'Are you sure you want to delete this role ?';
      this.openWarningDialog(deleteMsg).then((deleteConfirmation) => {
        // console.log(deleteConfirmation);
        if (deleteConfirmation) {
          this.userManagementService.DeleteRole(roleId).subscribe((res) => {
            if (res && res.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage('Role deleted successfully.', 'Success');
              this.bindRoleList(true);
            } else if (res && !res.success) {
              // this.openWarningDialog(res.error.message)
            }
          });
        }
      });


    }
  }

  open(roleId) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    };
    this.ngxLoaderService.start();
    const modalRef = this.modalService.open(EditRoleComponent, ngbModalOptions);
    modalRef.componentInstance.roleid = roleId;
    // console.log('modalRef', modalRef);
    modalRef.result.then(
      (result) => {
        if (result) {
          // console.log('Closed with: result', result);
        }
      },
      (reason) => {
        // console.log('Dismissed reason', reason);
      }
    );
    this.ngxLoaderService.stop();
    // this.modalService.open(content, ngbModalOptions).result.then(
    // 	(result) => {
    // 		this.closeResult = `Closed with: ${result}`;
    // 	},
    // 	(reason) => {
    // 		this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // 	},
    // );
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return 'by pressing ESC';
      case ModalDismissReasons.BACKDROP_CLICK:
        return 'by clicking on a backdrop';
      default:
        return `with: ${reason}`;
    }
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {

    }

  }

  async openWarningDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      // titleText: 'Warning',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    return result.isConfirmed;

  }

  async openErrorDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      // titleText: 'Warning',
      text: msg,
      icon: 'error',
      confirmButtonText: 'Yes',
      showDenyButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    return result.isConfirmed;

  }

  resetForm(): void {
    this.roleForm.reset();
    this.isFormSubmitted = false;
  }

}
